<div class="ghost-paragraphs">
  <div class="paragraph" *ngFor="let paragraph of paragraphs"></div>
</div>
